import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useComboCopyVariant } from '#src/app/pages/psf/promoteOrShare/shared/hooks';
import { interpolate } from '#src/app/pages/psf/promoteOrShare/shared/utils';

type Result = ModelHookResult<{
	// pluralized contributionHeroPlural copy from the psf_combo_copy_experiment FCM payload:
	// absence means "use the default copy"
	contributionHeroOverride: string | undefined;
}>;

export function useContributionHeroCopy(): Result {
	const {
		data: { variant },
	} = useComboCopyVariant();
	const {
		data: {
			petition: {
				promotionStats: { promoterCount, promoterCountLocalized },
			},
		},
	} = usePsfPromoteOrSharePageData();
	const { getLocale } = useI18n();
	const locale = getLocale();

	const forms = variant?.contributionHeroPlural;

	return {
		data: {
			contributionHeroOverride: useMemo(() => {
				// like the default copy, the hero line is hidden when there are no promoters
				if (!forms || promoterCount <= 0) return undefined;
				const form = forms[new Intl.PluralRules(locale).select(promoterCount)] ?? forms.other;
				return interpolate(form, { promoter_count: promoterCountLocalized });
			}, [forms, locale, promoterCount, promoterCountLocalized]),
		},
	};
}
